import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { config } from "../../shared/smartadmin.config";
import { Observable } from "rxjs/Observable";
import { IInventarioRequest, IProducto } from "../model/interfaces/inventario";

@Injectable()
export class InventarioService {
  refaccionesURL: string = config.API_DATA_URL + "/inventario";

  constructor(public http: HttpClient) {}

  public getCategorias(): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.refaccionesURL + "/GetCategorias", {
        headers,
      })
      .map((response: any) => {
        return response;
      })
      .catch(this.handleError);
  }

  public getInventario(request: IInventarioRequest): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(
        `${this.refaccionesURL}/GetInventario?nombre=${request.nombre}&idCategoria=${request.idCategoria}&pagina=${request.pagina}&registros=${request.registros}`,
        {
          headers,
        },
      )
      .map((response: any) => {
        return response;
      })
      .catch(this.handleError);
  }

  public getInventarioById(id: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(`${this.refaccionesURL}/GetInventarioById/${id}`, { headers })
      .map((response: any) => {
        return response;
      })
      .catch(this.handleError);
  }

  public ActualizarInventario(producto: IProducto) {
    const headers = this.getHeaders();
    const param = JSON.stringify(producto);
    return this.http
      .put(
        this.refaccionesURL + "/ActualizarInventario/" + producto.idProducto,
        param,
        { headers },
      )
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public AgregarInventario(producto: IProducto) {
    const headers = this.getHeaders();
    const param = JSON.stringify(producto);
    return this.http
      .post(this.refaccionesURL + "/AgregarInventario", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public eliminarInventario(id: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .delete(
        `${this.refaccionesURL}/EliminarInventario/${id}`,
        {
          headers,
        },
      )
      .map((response: any) => {
        return response;
      })
      .catch(this.handleError);
  }

  private getHeaders(): HttpHeaders {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    return headers;
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    const errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : "Server error";
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/api/inventario.service.ts